import { HttpErrorResponse } from '@angular/common/http';
import {
  PaymentAccount,
  PaymentInclusionExclusionRulesResponseV1,
} from '@arc/unified-payments-frontend/shared-payment';
import { createActionGroup, props } from '@ngrx/store';

export const HostedPaymentsSelectPaymentMethodPaymentRulesActions =
  createActionGroup({
    source: 'Hosted Payments Select Payment Method Payment Rules',
    events: {
      'Card Inclusion Exclusion List Updated': props<{
        payload: PaymentInclusionExclusionRulesResponseV1;
      }>(),
      'Card Inclusion Exclusion List Error': props<{
        payload: HttpErrorResponse;
      }>(),
      'Account Number And Card Restrictions Updated': props<{
        payload: PaymentAccount;
      }>(),
    },
  });
